import React from 'react';

import styles from './styles/info-box.module.css';

export default function InfoBox({ type, width }) {
    return (
        <div className={styles.wrapper} style={{ width: width }}>
            <p>
                글자 수 : 2자 이상, {type === 'CATEGORY' ? '50' : '100'}자 이하(공백 포함, 확장자 제외) <br />
                특수문자 제한 : \ / : * ? &quot; &lt; &gt; | # % &amp; {'{ }'} ^ ~ <br />
                연속된 특수문자 제한 : 연속된 하이픈(-)이나 언더바(_) <br />
            </p>
        </div>
    );
}
